module.exports = __webpack_public_path__ + "static/img/IMG_0908.0b07f3a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/IMG_0908.jpeg
// module id = rpa4
// module chunks = 0